import { combineReducers } from "@reduxjs/toolkit";

import type { InitiativeAction } from "entities/initiatives/actionTypes";
import { InitiativesType } from "entities/initiatives/actionTypes";
import type { InitiativeState } from "entities/initiatives/types";
import { addUserChangeReset } from "entities/user/utils";

const initialState: InitiativeState = { byId: {} };

const byId = (state = initialState.byId, action: InitiativeAction): InitiativeState["byId"] => {
  switch (action.type) {
    case InitiativesType.FETCH_FOR_TOPIC_SUCCESS: {
      return action.payload.data.reduce(
        (accumulator, next) => ({ ...accumulator, [next.id]: { ...state[next.id], ...next } }),
        state,
      );
    }
    case InitiativesType.FETCH_FOR_ID_SUCCESS: {
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export const initiativesReducer = combineReducers({
  byId: addUserChangeReset(byId, initialState.byId),
});
